import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { gridPageRequest } from '../../../model/common/common.model';
import { PaymentTermsGridResponse } from '../../../model/administration.model';
import { AdministratorService } from '../../../services/administrator.service';
import { TableRowSelectEvent } from 'primeng/table';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-termscode-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './termscode-lookup.component.html',
  styleUrl: './termscode-lookup.component.scss'
})
export class TermscodeLookupComponent implements OnInit {


  constructor(private PaymentTermsService: AdministratorService,private ref :DynamicDialogRef )  {
  }

  ngOnInit(): void {
    this.getPaymentTerms(this.pageRequest);
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }
  result: PaymentTermsGridResponse = {
    paymentTerms: [],
    totalRecords: 0
  }

  getPaymentTerms(query: gridPageRequest) {
    this.PaymentTermsService.getAllPaymentTerms(query).subscribe({
      next: data => {
        this.result = data as PaymentTermsGridResponse;
      },
      error: error => {
      }
    });
  }

  SelectOption(event: any) {
    if (event?.data) {
      this.ref.close(event?.data);
    } else {
      this.ref.close(event);
    }
  }


}
